const a = (t, e) => t.querySelector(`[slot="${e}"]`), l = (t, e) => !!a(t, e), r = (t, e) => t.querySelector(`[slot="${e}"]`), d = (t) => {
  var e;
  const n = (e = t.querySelector("slot:not([name])")) !== null && e !== void 0 ? e : !1;
  if (!n)
    return !1;
  const s = n.assignedNodes({ flatten: !0 });
  for (const o of s)
    if (o.nodeType !== 3 || o.nodeType === 3 && o.textContent.trim() !== "")
      return !0;
  return !1;
}, f = (t) => {
  var e;
  const n = (e = t.shadowRoot.querySelector("slot:not([name])")) !== null && e !== void 0 ? e : !1;
  if (!n)
    return !1;
  const s = n.assignedNodes({ flatten: !0 });
  for (const o of s)
    if (o.nodeType !== 3 || o.nodeType === 3 && o.textContent.trim() !== "")
      return !0;
  return !1;
};
export {
  d as a,
  f as b,
  r as g,
  l as h
};
